export default __webpack_public_path__ + "static/media/play.2249f7fe.svg";